export default class ReportStore {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/reports/report-store.js